
import { Component, EventEmitter, OnDestroy, OnInit, Output, TemplateRef} from '@angular/core';
import { NgbOffcanvas, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OnboardingModalComponent } from '../onboarding-modal/onboarding-modal.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/services/user/user.service';
import { DomSanitizer } from '@angular/platform-browser';
import { SocketioService } from 'src/app/services/socket/socketio.service';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { CommonService } from 'src/app/services/common.service';
import * as alertifyjs from 'alertifyjs';


@Component({
  selector: 'app-contacts-approvated',
  templateUrl: './contacts-approvated.component.html',
  styleUrls: ['./contacts-approvated.component.css']
})
export class ContactsApprovatedComponent implements OnInit,OnDestroy {
  form:any;
  people:any = [];
  loading:any;
  usersActives:any = {};
  socketServiceSub:any;
  submit_disabled:any;
  active_filter:any;
  people_total:any = 0;
   reload_loading:any;
   rows_number = 0;
   rows_size = 10;
   reload_loading_pluss =true;
   rows:any = [];
   rows_temp:any = [];

   approveStatus:any  = 'ALL';
   biometricStatus:any  = 'ALL';
   onboardingStatus:any  = 'ALL';

   usQuoteClien:any = false;
   reloadStadisticLoading:any;




    supUse = false;

    meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
  
   @Output() changeView = new EventEmitter<any>();

    page = 1; // Current page number
    limit = 50; // Number of documents per page

   search_form: any = '';
   config_line:any;
   sessionUser:any;


   constructor(
    private offcanvasService: NgbOffcanvas,
    private modalService: NgbModal,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private _user:UserService,
    private _commonService:CommonService,

    private sanitizer: DomSanitizer,
    public socketService: SocketioService,
    public _auth : AuthService


  ) { }
  ngOnDestroy(): void {

    this.socketServiceSub.unsubscribe();
    
  }

  ngOnInit(): void {
   

    this._auth.auth$.subscribe((rep: any) => {

      this.sessionUser = rep? this._auth.sessionUser: null; 

      //nathalyaespisona@totalmundo.com
 });

    this.getPeople();

    this.socketServiceSub = this.socketService.usersActives.subscribe((resp: any) => {
      // this.usersActives = resp.filter((item:any) => item.uid != this.uid);
  
      this.usersActives = {};
 
       resp?.map((item:any)=>{
 
       if(item?.role ==  "CLIENT_ROLE"){
 
         this.usersActives[item?.person_code] = true;
 
       };
 
       return item;
 
      });


     });

    // this.setChartLine();    

  }

  openBottom(content: TemplateRef<any>,data:any= {}) {

    this.offcanvasService.open(content, { position: 'bottom',keyboard: false} );

  }

  closeAddClient(){
    this.getPeople();
    this.offcanvasService.dismiss("");
    
  }


  getPeople = async (filter_d:any = false) =>  {
    this.loading = true;

    this.rows = filter_d? [] :  this.rows;
    this.people_total = filter_d? 0 :  this.people_total;

    let filter:any = {

      page:this.page,
      limit: this.limit
 
     }

     if(filter_d){
      filter.page = 1; 
      filter.limit = 50; 
    }
  

    if(this.search_form?.trim() != ''){

  

      let code_ejecutive =  {f_all:this.search_form?.trim()}

        filter = {...filter,...code_ejecutive}

      }

    if(this._auth.IsPermitid(['EJECUTIVE'])){

   //  let code_ejecutive =  {code_ejecutive:this.sessionUser?.uid}

     // filter = {...filter,...code_ejecutive}

    }

      if(this.approveStatus != 'ALL'){

     let temp =  {approveStatus:this.approveStatus}

      filter = {...filter,...temp}
        
      }


      if(this.biometricStatus != 'ALL'){

        let temp =  {biometricStatus:this.biometricStatus}
   
         filter = {...filter,...temp}
           
         }


      if(this.onboardingStatus != 'ALL'){

        let temp =  {onboardingStatus:this.onboardingStatus}
   
         filter = {...filter,...temp}
           
         }
   


      if(this.usQuoteClien){

        let temp =  {reviewStatus:true}
   
         filter = {...filter,...temp}
           
         }
   

      

         debugger
    
    const resp =  await this._user.getPeople_status(filter);
    let result  = resp?.result?.users;
    this.people_total = resp?.result?.total;

    debugger
    let people:any = this.rows;
    let rows =  people.concat(result);

   // this.nextRows();

   this.rows = rows;


    this.loading = false;

  }


  nextRows = () =>{
/*
    this.reload_loading_pluss =true;

this.rows_number = this.rows_number + this.rows_size;

if(this.rows_number > this.people?.lenght){
 this.rows_number = this.people?.lenght;
}

let rows = this.people?.slice(0, this.rows_number);
this.rows = rows;

this.reload_loading_pluss = false;
  */


this.page = this.page + 1 ; 
this.getPeople();


  }

  
  getIdentity(item:any){

    if(!(item?.identitys?.length > 0))
      return "";

      return `${item?.identitys[0]?.type_identity?.name} ${item?.identitys[0]?.code_identity?.name}-${item?.identitys[0]?.identity}`;
  }



sanitize(url: string) {
  //return url;
  return this.sanitizer.bypassSecurityTrustUrl(url);
}
onScrollDown() {
  if(!this.active_filter){

   // this.nextRows();

   }

  console.log("scrolled down!!");
}

onScrollUp() {
  
  console.log("scrolled up!!");
}


  onScroll() {

    console.log("scrolled!!");
  }

  search_form_method() {

if(this.search_form?.trim() != ''){

  this.active_filter = true;

      this.rows_temp = this.rows_temp?.length > 0? this.rows_temp : this.rows;

      let datas:any = [];
      
       datas =  this.people?.filter((element:any) =>{

        let name =  element?.person?.name;
        let lastName =  element?.person?.lastName;
        let ename =  element?.person?.ejecutive?.name;
        let elastName =  element?.person?.ejecutive?.lastName;
        let identity = this.getIdentity(element)

      
        let resp = 
        identity.toLowerCase().includes(this.search_form) ||
         name.toString().toLowerCase().indexOf(this.search_form.toLowerCase()) !== -1 ||
         lastName.toString().toLowerCase().indexOf(this.search_form.toLowerCase()) !== -1;
        //  ename.toString().toLowerCase().indexOf(this.search_form.toLowerCase()) !== -1 ||
        //  elastName.toString().toLowerCase().indexOf(this.search_form.toLowerCase()) !== -1;
         

        return resp;
      });
      
      this.rows= datas;


      }else{
             

            this.rows = this.rows_temp?.length > 0? this.rows_temp : this.rows;
            this.active_filter = false;

      }

   }


setChartLine(){


  let dataList:any = [];
  
  let colors = [
          'orange',
          'blue',
          'grey',
          'green',
          'purple',
  ];


    let colorsBorder = [
      'purple',
      'yellow',
      'grey',
      'green',
      'purple',
  ];
    

  


      
  
  
    let datasets =  [
      {
        label: 'Dataset 1',
        data: 20,
        borderColor: colors[0],
        backgroundColor: colors[2],
        stack: 'combined',
        type: 'bar'
      },
      {
        label: 'Dataset 2',
        data: 30,
        borderColor: colors[3],
        backgroundColor: colors[4],
        stack: 'bar'
      }
    ]
    
  
  
   const labels =["Enero", "Febrero"];



   this.config_line = {
  
      type: 'line', //this denotes tha type of chart
      data: {// values on X-Axis
        labels: labels, 
         datasets: datasets
      },
      options: {
        plugins: {
          title: {
            display: true,
            text: 'Chart.js Stacked Line/Bar Chart'
          }
        },
        scales: {
          y: {
            stacked: true
          }
        }
      },
      
    };
    
  
  }



  toogleStatusClient = async (st = this.usQuoteClien) => {
    let status = st ? true : false;

    this.usQuoteClien = status

    this.getPeople(true);

  };

  executeReview = async () => {
    await this._commonService.updateReview();
    alertifyjs.success(`Se realizó el refresh`);

  }

  // Método de debug para ver el item completo
  debugAndOpenModal(item: any) {
    console.log('=== DEBUG ITEM COMPLETO ===');
    console.log('Item completo:', item);
    console.log('item.params:', item?.params);
    console.log('item.params.code:', item?.params?.code);
    console.log('item.person:', item?.person);
    console.log('item.person.code:', item?.person?.code);
    
    // Intentar obtener el código de diferentes lugares
    const personCode = item?.params?.code || item?.person?.code || item?.code;
    console.log('Código final a usar:', personCode);
    
    if (personCode) {
      this.openOnboardingModal(personCode);
    } else {
      console.error('No se pudo encontrar código de persona en el item');
      alertifyjs.error('No se pudo obtener el código del cliente');
    }
  }

  // Método para abrir modal de onboarding
  openOnboardingModal(personCode: string) {
    console.log('=== INICIO openOnboardingModal ===');
    console.log('personCode recibido:', personCode);
    console.log('Tipo de personCode:', typeof personCode);
    console.log('personCode es válido:', !!personCode);
    
    if (!personCode || personCode === 'undefined' || personCode === 'null') {
      console.error('ERROR: Código de persona no válido:', personCode);
      alertifyjs.error('Código de persona no válido');
      return;
    }

    // Verificar si NgBootstrap está disponible
    if (!this.modalService) {
      console.error('NgBootstrap Modal Service no está disponible');
      this.fallbackToNavigation(personCode);
      return;
    }

    try {
      console.log('Abriendo modal...');
      const modalRef = this.modalService.open(OnboardingModalComponent, {
        size: 'xl',
        fullscreen: true,
        backdrop: 'static',
        keyboard: false,
        windowClass: 'onboarding-modal'
      });
      
      console.log('Modal abierto, configurando datos...');
      
      // Verificar que el componente se creó correctamente
      if (modalRef.componentInstance) {
        modalRef.componentInstance.personCode = personCode;
        modalRef.componentInstance.fromRevision = true;
        console.log('Datos configurados en modal:', {
          personCode: modalRef.componentInstance.personCode,
          fromRevision: modalRef.componentInstance.fromRevision
        });
      } else {
        throw new Error('No se pudo crear la instancia del componente modal');
      }
      
      console.log('Configurando callbacks...');
      // Al cerrar, actualizar datos
      modalRef.result.then(
        (result) => {
          console.log('Modal cerrado con resultado:', result);
          this.refreshCurrentView();
          if (result && result.success) {
            alertifyjs.success('Cliente actualizado correctamente');
          }
        },
        (dismissed) => {
          console.log('Modal cerrado/cancelado:', dismissed);
          this.refreshCurrentView();
        }
      ).catch((error) => {
        console.error('Error en modal result:', error);
        this.refreshCurrentView();
      });
      
      console.log('Modal configurado correctamente');
    } catch (error) {
      console.error('Error al abrir modal:', error);
      const errorMessage = error instanceof Error ? error.message : 'Error desconocido';
      alertifyjs.error('Error al abrir la revisión del cliente: ' + errorMessage);
      this.fallbackToNavigation(personCode);
    }
  }

  // Método fallback para navegación normal
  private fallbackToNavigation(personCode: string) {
    console.log('Usando fallback - navegación normal');
    this.router.navigate(['/console/person/onboarding/', personCode], {
      queryParams: { fromRevision: true }
    });
  }

  // Método para refrescar sin perder contexto
  refreshCurrentView() {
    // Mantener filtros actuales
    const currentFilters = {
      approveStatus: this.approveStatus,
      biometricStatus: this.biometricStatus,
      onboardingStatus: this.onboardingStatus,
      usQuoteClien: this.usQuoteClien,
      search_form: this.search_form
    };
    
    // Recargar datos manteniendo filtros
    this.getPeople(true);
    
    // Mostrar notificación de actualización
    alertifyjs.success('Vista actualizada correctamente');
  }


}
